export default __webpack_public_path__ + "static/media/dollar.98751752.svg";